export interface BannerTier {
  id: string;
  value: string;
}

export enum TimeUnit {
  MONTH = 'Month',
  DAY = 'Day',
}
